export const locations = {
  miamiDade: [
    {
      title: "HEADQUARTERS AIRPORT/DORAL AREA",
      address: "7500 N.W. 25th Street #119",
      city: "Miami, FL 33122",
      phone: "305-513-0063",
      fax: "305-593-7077",
      email: "contact@metrotrafficschool.com",
      directions:
        "https://maps.google.com/?q=7500+N.W.+25th+Street+119+Miami+FL+33122",
    },
    {
      title: "N. DADE AREA",
      address: "180 NW 183 ST #113",
      city: "Miami, FL 33169",
      phone: "305-553-5000",
      fax: "305-654-0019",
      email: "contact@metrotrafficschool.com",
      directions: "https://maps.google.com/?q=180+NW+183+ST+113+Miami+FL+33169",
    },
    {
      title: "WEST DADE/FIU AREA",
      address: "1321 SW 107 Ave #213A",
      city: "Miami, FL 33174",
      phone: "305-226-9004",
      fax: "",
      email: "contact@metrotrafficschool.com",
      directions:
        "https://maps.google.com/?q=1321+SW+107+Ave+213A+Miami+FL+33174",
    },
  ],
  broward: [
    {
      title: "NORTH BROWARD AREA",
      address: "700 W. Hillsboro Blvd. Bldg 4 #104",
      city: "Deerfield Beach, FL 33441",
      phone: "954-422-5757",
      fax: "754-333-8556",
      email: "contact@metrotrafficschool.com",
      directions:
        "https://maps.google.com/?q=700+W.+Hillsboro+Blvd.+Bldg+4+104+Deerfield+Beach+FL+33441",
    },
    {
      title: "WEST BROWARD AREA",
      address: "5139 South University Drive",
      city: "Davie, FL 33328",
      phone: "954-476-0055",
      fax: "954-476-0033",
      email: "contact@metrotrafficschool.com",
      directions:
        "https://maps.google.com/?q=5139+South+University+Drive+Davie+FL+33328",
    },
    {
      title: "CENTRAL BROWARD AREA",
      address: "3726 W. Oakland Park Blvd",
      city: "Ft. Lauderdale, FL 33311",
      phone: "954-422-5757",
      fax: "954-535-7699",
      email: "contact@metrotrafficschool.com",
      directions:
        "https://maps.google.com/?q=3726+W.+Oakland+Park+Blvd+Ft.+Lauderdale+FL+33311",
    },
  ],
  palmBeach: [
    {
      title: "CENTRAL PALM BEACH AREA",
      address: "1993 S. Military Trail",
      city: "West Palm Beach, FL 33415",
      phone: "(561) 963-7555",
      fax: "(561) 649-8286",
      email: "contact@metrotrafficschool.com",
      directions:
        "https://maps.google.com/?q=1993+S.+Military+Trail+West+Palm+Beach+FL+33415",
    },
    {
      title: "SOUTH PALM BEACH AREA",
      address: "4731 West Atlantic Avenue, Suite B-3",
      city: "Delray Beach, FL 33445",
      phone: "561-395-8989",
      fax: "561-894-8547",
      email: "contact@metrotrafficschool.com",
      directions:
        "https://maps.google.com/?q=4731+West+Atlantic+Avenue+Suite+B-3+Delray+Beach+FL+33445",
    },
    {
      title: "NORTH PALM BEACH/ AIRPORT AREA",
      address: "1280 North Congress Ave, Suite 100",
      city: "West Palm Beach, FL 33409",
      phone: "561-651-7004",
      fax: "561-429-4794",
      email: "contact@metrotrafficschool.com",
      directions:
        "https://maps.google.com/?q=1280+North+Congress+Ave+Suite+100+West+Palm+Beach+FL+33409",
    },
  ],
  centralFlorida: [
    {
      title: "ORANGE - SEMINOLE - LAKE - OSCEOLA",
      address: "37 N. Orange Ave., Suite 547",
      city: "Orlando FL 32801",
      phone: "407-502-0099",
      fax: "",
      email: "contact@metrotrafficschool.com",
      directions:
        "https://maps.google.com/?q=37+N.+Orange+Ave.+Suite+547+Orlando+FL+32801",
    },
  ],
};
